module.exports = __webpack_public_path__ + "img/chat_bookmark_inactive.fe83fd31.svg";